import { Inject, Injectable } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { firstValueFrom, of } from 'rxjs';
import {
  SystemParameterRequestViewModel,
  SystemParameterResponseViewModel,
  SystemParameterService,
} from '../../common-api/rt-common-api/system-parameter';
import {
  RbacService,
  UserProfileEditModel,
} from '../../common-api/system-management-api';
import {
  CacheService,
  MEMORY_CACHE_SERVICE,
} from '../../common/services/cache.service';
import { Logger } from '../../common/services/logger.service';
import { ContextData } from '../../core/models';
import { isNullOrEmpty } from '../../core/utils';
import { MemoryCache } from '../enums/memory-cache.enum';
import { RoleEnum } from '../enums/rbac-role.enum';
import { optionConvertKeyCombineName } from '../utils/convertors';
import { getCompanyId } from '../utils/user-profile-utils';
/**
 * 角色對應代碼取得服務
 */
@Injectable({
  providedIn: 'root',
})
export class GetRoleCodeService {
  constructor(
    @Inject(MEMORY_CACHE_SERVICE) private cacheService: CacheService,
    private _logger: Logger,
    private rbacService: RbacService,
    private contextData: ContextData,
    private systemParameterService: SystemParameterService
  ) {}
  /**
   * 依據RoleEnum取得Rbac對應roleCode
   * @param code
   * @returns
   */
  async getRoleCode(code: RoleEnum): Promise<string> {
    const commonDropdownCache =
      this.cacheService.get<any[]>(MemoryCache.RETAIL_ROLE_CODE_CACHE_KEY) ??
      [];
    const cacheOptions = commonDropdownCache;
    const useMapping =
      cacheOptions.length > 0
        ? await firstValueFrom(of(cacheOptions))
        : await this.getRoleCodeMappingService();
    return this.processMappingCode(useMapping, code);
  }

  /**
   * 取得role code mapping
   * @returns
   */
  private async getRoleCodeMappingService() {
    const systemParameterRequest: SystemParameterRequestViewModel = {
      applicableCompany: getCompanyId().toString(),
      paramType: 'RbacRoleCode',
    };
    const useRoleCodeList = await firstValueFrom(
      this.systemParameterService.commonSystemParameterEnquiryAllByTypePost(
        systemParameterRequest
      )
    );
    this.cacheService.add(
      MemoryCache.RETAIL_ROLE_CODE_CACHE_KEY,
      useRoleCodeList
    );

    return useRoleCodeList;
  }

  /**
   * 依照公司別roleEnum取得Rbac對應roleCode
   * @param useFullMapping
   * @param useRoleEnum
   * @returns
   */
  private processMappingCode(
    useFullMapping: SystemParameterResponseViewModel[],
    useRoleEnum: RoleEnum
  ): string {
    let useRoleCode = undefined;
    const useRoleMap = useFullMapping;

    if (useRoleMap) {
      useRoleCode = useRoleMap.find(
        (x) => x.paramName == useRoleEnum
      )?.paramCode;
    }
    if (isNullOrEmpty(useRoleCode)) {
      this._logger.info(
        'processMappingCode no match role code',
        useFullMapping,
        useRoleCode,
        useRoleMap
      );
      throw new Error('no match role code')
    }
    return useRoleCode ?? '';
  }

  async getUserOptionsListByRoleEnum(
    useRoleEnum: RoleEnum
  ): Promise<SelectItem<any>[]> {
    let rbacUserList = [] as UserProfileEditModel[];
    let processedOptionsList = [] as SelectItem[];
    rbacUserList = await firstValueFrom(
      this.rbacService.rbacUserProfileRoleRoleCodeRoleCodeGet(
        await this.getRoleCode(useRoleEnum)
      )
    );
    const handlers: UserProfileEditModel[] = rbacUserList.filter(
      (x) => x.enable
    );
    return (processedOptionsList = optionConvertKeyCombineName(
      handlers,
      'userName',
      'userNo',
      ' '
    ));
  }
}
